<ng-container *ngIf="currencies">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h6 class="mb-0 small text-uppercase fw-semibold text-secondary">Unit Conversion</h6>
    <button type="button" class="btn btn-sm btn-link text-decoration-none p-0" (click)="setUnitsDefault($event)">
      <i class="fas fa-rotate-left me-1"></i>Set Default
    </button>
  </div>

  <div class="d-flex flex-column gap-2">
    <div class="input-group input-group-sm" *ngFor="let item of customUnits[baseUnit.code] | keyvalue">
      <span class="input-group-text rate-label">{{baseUnit.code}} / {{item.key}}</span>
      <input class="form-control rate-input text-end font-monospace"
             type="text"
             [(ngModel)]="customUnits[baseUnit.code][item.key]"
             (ngModelChange)="onCustomUnit($event)"
             [ngModelOptions]="{standalone: true}">
    </div>
  </div>
</ng-container>
